import styled from 'styled-components';
import NumericInput from '../../../../components/utils/inputs/NumericInput/NumericInput';

export const PricingForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const PriceGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const PriceRow = styled.div`
  display: flex;
  gap: 1.4rem;
  max-width: 48rem;
`;

// Error container below the input reserves 2.1rem; input is 4.8rem tall.
// Anchor the prefix to the input's vertical center instead of a magic top offset.
export const PriceInput = styled(NumericInput)`
  input {
    padding-left: 3rem;
  }

  > span {
    top: auto;
    bottom: calc(2.1rem + 2.4rem);
    transform: translateY(50%);
    left: 1.6rem;
    font-size: 1.5rem;
    line-height: 1;
    pointer-events: none;
  }
`;
